import { Suspense } from "react";
import PageLoading from "./PageLoading";

const LazyLoader = (Component) => {
  const WrappedComponent = (props) => (
    <Suspense fallback={<PageLoading />}>
      <Component {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = `LazyLoader(${Component.displayName || Component.name || "Component"})`;

  return WrappedComponent;
};

export default LazyLoader;
